<script
  setup
  lang="ts"
  generic="
    T extends { name: HouseSlug; first_photo_url: string; houses_count: number }
  "
>
import type { HouseSlug } from 'lc-services/types'
import type { ImgHTMLAttributes } from 'vue'

const { destinations, imgAttrs = { height: 83, width: 145 } } = defineProps<{
  destinations: Array<T>
  imgAttrs?: ImgHTMLAttributes
}>()
defineEmits<{ 'click-destination': [T] }>()
const { locale } = useI18n()
</script>

<template>
  <div
    class="grid grid-cols-2 items-start gap-x-2 gap-y-4 md:grid-cols-4 md:gap-y-8"
  >
    <template v-if="destinations.length">
      <button
        v-for="desti in destinations"
        :key="desti.name[locale]"
        class="text-left"
        type="button"
        @click.stop="$emit('click-destination', desti)"
      >
        <div class="mb-2">
          <BaseNuxtImg
            :alt="desti.name[locale]"
            :src="desti.first_photo_url"
            class="rounded"
            loading="lazy"
            quality="100"
            v-bind="imgAttrs"
          />
        </div>
        <div class="text-md font-medium leading-5">
          {{ desti.name[locale] }}
        </div>
        <div class="text-xs leading-4 text-gray-500">
          {{
            $t('search.propertyCount', {
              count: desti.houses_count,
            })
          }}
        </div>
      </button>
    </template>

    <template v-else>
      <div v-for="n in 12" :key="n" class="flex w-full flex-col gap-2">
        <div class="h-24 w-full animate-pulse rounded bg-gray-200" />
        <div class="h-9 w-full animate-pulse bg-gray-200" />
      </div>
    </template>
  </div>
</template>
